export default {
    modelTitle: '${title}',
    modelTitleWithContinue: 'Step 1: ${title}',
}